import { useEffect } from 'react';

import { localStorage } from '@change-corgi/core/storage';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useCurrentAuthenticatedUser } from 'src/app/shared/hooks/session';
import { getLoginOrJoinMethod, LOGIN_OR_JOIN_METHOD_QUERY_KEY } from 'src/app/shared/utils/loginOrJoin';

import type { Draft } from '../../types';

// TODO: all of this needs to be moved into the api layer
export function useInitialDraft(draft: Draft): Draft {
	/**
	 * User Metadata
	 * id - always keep an reference to the current user id
	 * initialLoginState - which state the user started the flow in
	 * loginOrJoinMethod - initializes after the user authenticates
	 */

	const user = useCurrentAuthenticatedUser();
	const loginOrJoinMethodShortcode = useQueryParamValue(LOGIN_OR_JOIN_METHOD_QUERY_KEY) ?? '';
	const loginOrJoinMethod = getLoginOrJoinMethod(loginOrJoinMethodShortcode) ?? undefined;
	const getUserState = () => {
		const currentUserState = user?.id ? ('AUTHENTICATED' as const) : ('GUEST' as const);
		return {
			id: user?.id,
			initialLoginState: draft.metadata?.user?.initialLoginState || currentUserState,
			loginOrJoinMethod,
		};
	};

	useEffect(() => {
		// Clear existing local draft if any exists
		const existingDraftId = localStorage.getItem('draft-id');
		if (existingDraftId) {
			localStorage.removeItem('draft-id');
			localStorage.removeItem(`draft-${existingDraftId}`);
		}
	}, []);

	// clear petition data if:
	// - current authenticated user id does not match the stored user id
	const didUserChange = draft.metadata?.user?.id && user?.id !== draft.metadata.user.id;
	if (didUserChange) return { id: draft.id };

	return { ...draft, metadata: { ...draft.metadata, user: getUserState() } };
}
